import { createGlobalStyle } from "styled-components";

import { CryptoFont } from "../../shared/fonts";

const CryptoFontCSS = createGlobalStyle`
    ${CryptoFont};
`;

export default CryptoFontCSS;
